

function ChangeTheNumberOfCarts() {
  fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((response) => response.json()).then((response) => {
    // console.log('response json: ',response);
    console.log('response.item_count: ',response.item_count);
    let cart_count_content_wap=document.getElementById('cart_count_content_wap');
    let cart_count_content=document.getElementById('cart_count_content');
    if(cart_count_content){
      if (response.item_count){
        cart_count_content_wap.style.display='flex';
        cart_count_content.innerHTML=response.item_count;
      }else {
        cart_count_content_wap.style.display='none';
      }
    }
  })
}
